<template>
  <Popup size="md" :alert-btn="false" @close="$emit('close')">
    <h5 class="alert-heading">
      {{ $t('changePassword.title') }}
    </h5>
    <div class="w-100 text-left">
      <form-input
        v-model="user.account"
        :label="$t('changePassword.form.account.label')"
        :placeholder="$t('changePassword.form.account.placeholder')"
        readonly
      />
      <form-input
        v-model="form.password.value"
        :error="form.password.error"
        type="password"
        :label="$t('changePassword.form.password.label')"
        :placeholder="$t('changePassword.form.password.placeholder')"
        :hint="$t('changePassword.form.password.hint')"
        required
        @input="onPasswordInput"
      />
      <form-input
        v-model="form.confirmPassword.value"
        :error="form.confirmPassword.error"
        type="password"
        :label="$t('changePassword.form.confirmPassword.label')"
        :placeholder="$t('changePassword.form.confirmPassword.placeholder')"
        required
        @input="onConfirmPasswordInput"
      />
    </div>
    <div class="mt-3">
      <button class="mx-1 btn btn-sm btn-primary rounded-pill" @click="submitAsync">
        <span class="px-3">{{ $t('changePassword.form.submit') }}</span>
      </button>
    </div>
  </Popup>
</template>

<script>
import Popup from '@/components/Popup.vue';
import Input from '@/components/FormModule/Input.vue';
import { PasswordFormatValidate } from '@/services/AccountService';
import { IssueTempAsync, RevokeAsync } from '@/services/AuthenticationService';
import PermissionService from '@/services/PermissionService';

export default {
  components: {
    Popup,
    'form-input': Input
  },
  props: ['user'],
  data() {
    return {
      accessToken: '',
      accessTokenExpired: 0,
      form: {
        password: {
          value: '',
          error: ''
        },
        confirmPassword: {
          value: '',
          error: ''
        }
      }
    };
  },
  async created() {
    await this.loadSpecAsync();
  },
  async destroyed() {
    if ((this.accessToken || '') !== '') {
      await RevokeAsync(this.accessToken);
    }
  },
  methods: {
    Unauthorized() {
      this.$emit('close');
      this.$popup.alert(this.$t('changePassword.unauthorized'));
    },
    Success() {
      this.$emit('close');
      this.$notify.success(this.$t('changePassword.success'));
    },
    async loadSpecAsync() {
      try {
        const spec = await IssueTempAsync(this.user.token) || {};
        this.accessToken = spec.access_token || '';
        this.accessTokenExpired = spec.expires_in || 0;
      } catch (err) {
        this.Unauthorized();
      }
    },
    async submitAsync() {
      if ([this.validatePassword(), this.validateConfirmPassword()].every((v) => v)) {
        await this.$loading(async () => {
          try {
            await PermissionService.ModifyUserPasswordAsync(this.accessToken, this.form.password.value);
            this.Success();
          } catch (err) {
            const resp = err.response || {};
            if (resp.status === 401) {
              this.Unauthorized();
            } else {
              this.submitErrorProcess(resp.data || {});
              this.$notify.saveFailed();
            }
          }
        });
      }
    },
    submitErrorProcess(data) {
      this.form.password.error = '';

      if ((data.status || '') !== '') {
        switch (data.status) {
          case '409':
            this.form.password.error = this.$t('changePassword.form.password.feedback.historyFail');
            break;
          default:
            break;
        }
      }
    },
    onPasswordInput() {
      if (this.form.password.error.trim().length !== 0) {
        this.validatePassword();
      }
    },
    onConfirmPasswordInput() {
      if (this.form.confirmPassword.error.trim().length !== 0) {
        this.validateConfirmPassword();
      }
    },
    validatePassword() {
      this.form.password.error = '';

      if ((this.form.password.value || '').trim().length === 0) {
        this.form.password.error = this.$t('changePassword.form.password.placeholder');
      } else if (!PasswordFormatValidate(this.form.password.value)) {
        this.form.password.error = this.$t('changePassword.form.password.feedback.regex');
      } else if (this.form.password.value === this.user.account) {
        this.form.password.error = this.$t('changePassword.form.password.feedback.accountDuplicate');
      }

      return this.form.password.error === '';
    },
    validateConfirmPassword() {
      this.form.confirmPassword.error = '';

      if ((this.form.confirmPassword.value || '').trim().length === 0) {
        this.form.confirmPassword.error = this.$t('changePassword.form.confirmPassword.placeholder');
      } else if (this.form.confirmPassword.value !== this.form.password.value) {
        this.form.confirmPassword.error = this.$t('changePassword.form.confirmPassword.feedback.equal');
      }

      return this.form.confirmPassword.error === '';
    }
  }
};
</script>
